import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import type { SampleRequestFilterValues } from './types';

type UrlFilterState = SampleRequestFilterValues & { search: string };

const ARRAY_PARAMS: Array<keyof SampleRequestFilterValues> = [
  'quoteStatus',
  'prevSampleStatus',
  'counterSampleStatus',
  'priorities',
  'vendorContacts',
];

function parseArrayParam(value: string | null): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function readFiltersFromUrl(locationSearch: string): UrlFilterState {
  const params = new URLSearchParams(locationSearch);
  const result: UrlFilterState = {
    quoteStatus: [],
    prevSampleStatus: [],
    counterSampleStatus: [],
    priorities: [],
    vendorContacts: [],
    filters: '',
    search: '',
  };

  result.quoteStatus = parseArrayParam(params.get('quoteStatus'));
  result.prevSampleStatus = parseArrayParam(params.get('prevSampleStatus'));
  result.counterSampleStatus = parseArrayParam(
    params.get('counterSampleStatus'),
  );
  result.priorities = parseArrayParam(params.get('priorities'));
  result.vendorContacts = parseArrayParam(params.get('vendorContacts'))
    .map(Number)
    .filter((n) => !isNaN(n));

  result.filters = params.get('filters') || '';
  result.search = params.get('search') || '';
  return result;
}

export function useUrlFilters() {
  const history = useHistory();

  const syncToUrl = useCallback(
    (state: UrlFilterState) => {
      const params = new URLSearchParams(history.location.search);

      const counterId = params.get('counter_id');
      const newParams = new URLSearchParams();
      if (counterId) newParams.set('counter_id', counterId);

      if (state.search) newParams.set('search', state.search);

      for (const key of ARRAY_PARAMS) {
        const arr = state[key];
        if (Array.isArray(arr) && arr.length > 0) {
          newParams.set(key, arr.join(','));
        }
      }

      if (state.filters) newParams.set('filters', state.filters);

      history.replace({
        pathname: history.location.pathname,
        search: newParams.toString(),
      });
    },
    [history],
  );

  return { syncToUrl };
}
